import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const getDefaultState = () => ({
  query: "",
  categories: [],
  currentCategory: null
});

const store = new Vuex.Store({
  modules: {
    datasets: {
      namespaced: true,
      state: getDefaultState(),
      actions: {
        setSearch({ commit }, query) {
          commit("setSearch", query);
        },
        addCategory({ commit, state }, category) {
          if (state.categories.indexOf(category) !== -1) return;

          commit("addCategory", category);
        },
        selectCategory({ commit }, category) {
          commit("selectCategory", category);
        },
        removeCategory({ commit, state }, category) {
          if (state.categories.indexOf(category) === -1) return;

          commit("removeCategory", category);
        },
        resetState({ commit }) {
          commit("resetState");
        }
      },
      mutations: {
        setSearch(state, query) {
          state.query = query;
        },
        addCategory(state, category) {
          state.categories.push(category);
        },
        selectCategory(state, category) {
          state.currentCategory = category;
        },
        removeCategory(state, category) {
          const index = state.categories.indexOf(category);
          state.categories.splice(index, 1);
        },
        resetState(state) {
          Object.assign(state, getDefaultState());
        }
      },
      getters: {
        getCurrentCategoryCount: state => items => {
          const current = items.find(item => {
            return item.name === state.currentCategory;
          });
          return current ? current.count : null;
        }
      }
    }
  }
});

export default store;
